import API_BASE_URL from '../../Config/api';
import authHeader from '../Customer/authHeader';

// Opens Google's consent screen for connecting Drive/Gmail. The server only
// hands the Google URL to signed-in staff, so fetch it with the session token
// first. The popup is opened straight away (still inside the click) so popup
// blockers allow it, then pointed at Google once the URL arrives.
// Returns the popup window, or null if it couldn't be started.
const connectGoogleDrive = async (windowName, features) => {
  const popup = window.open('', windowName, features);
  try {
    const response = await fetch(`${API_BASE_URL}/api/oauth/auth-url`, authHeader());
    if (!response.ok) {
      if (popup) popup.close();
      alert(response.status === 401
        ? 'Your session has expired. Please sign in again.'
        : 'Only staff can connect Google Drive.');
      return null;
    }
    const { authUrl } = await response.json();
    if (popup) {
      popup.location.href = authUrl;
    } else {
      window.location.href = authUrl; // popup blocked: use this tab instead
    }
    return popup;
  } catch (error) {
    if (popup) popup.close();
    console.error('Error starting Google authentication:', error);
    alert('Could not start Google sign-in. Please try again.');
    return null;
  }
};

export default connectGoogleDrive;
